import release from './release';
import releaseAction from './release-action';

export const routes = {
  release,
  'release-action': releaseAction,
};
